module.exports = __webpack_public_path__ + "static/media/ro-RO.132d0c4d.md";